import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import {
    StatusResponse,
    StatusResponseSchema,
} from "../response/RateImportResponse";

const API_VERSION = "v4";

export interface UseRateImportStatusOptions {
    /** Aktifkan polling. Default: aktif hanya ketika importId tersedia. */
    enabled?: boolean;
    /** Interval polling (ms). Default 2000. */
    refetchInterval?: number;
}

/**
 * Custom hook untuk polling status Import Rates.
 * Polling berhenti otomatis ketika status 'completed' atau 'failed'.
 */
export const useRateImportStatus = (
    importId: string | null | undefined,
    options?: UseRateImportStatusOptions
) => {
    const pollInterval = options?.refetchInterval ?? 2000;
    const enabled = (options?.enabled ?? true) && !!importId;

    return useQuery<StatusResponse>({
        queryKey: ["rate-import-status", importId],
        enabled,
        queryFn: async () => {
            const response = await privateApi.get(
                `/${API_VERSION}/rate-import/${importId}/status`
            );

            return StatusResponseSchema.parse(response.data);
        },
        refetchInterval: (query) => {
            const status = query.state.data?.data.status;
            if (status === "completed" || status === "failed") {
                return false;
            }
            return pollInterval;
        },
        refetchOnWindowFocus: false,
    });
};
